import React from 'react';
import NotFoundDailyUI from './Pages/NotFoundDailyUI';
import { Route, Routes } from 'react-router-dom';


function App() {
  return (
    <div>
    <Routes>
      <Route path="/hi/" element={<NotFoundDailyUI/>}/>
      <Route path="/" element={<HII/>}/>
    </Routes>
    </div>
  );
}



export const HII = () => {
  return (
    <h1>HII</h1>
  )
}


export default App;
